import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from '@mui/material';

import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { AddClientDependent, DeleteClientDependent, GetClient } from '../services/httpServices';

import styled from '@emotion/styled';
import { Trash } from 'react-feather';
import ModalLayout from 'src/theme/Modal';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));
const ClientDependents = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  let { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [client, setClient] = useState({});

  const nameRef = useRef('');
  const dateOfBirthRef = useRef('');
  const passportNoRef = useRef('');
  const uciNoRef = useRef('');

  const fetchClient = async (event) => {
    const client = await GetClient(props.id);
    //console.log('client:', client);
    setClient(client);
    setLoading(false);
  };
  useEffect(() => {
    fetchClient();
  }, [location]);
  // #endregion Refs

  const SaveUser = async (event) => {
    // setPosting(true);
    setLoading(true);
    event.preventDefault();
    //console.log('saveHit');
    const payload = {
      id: props.id,
      name: nameRef.current.value,
      dateOfBirth: dateOfBirthRef.current.value,
      passportNo: passportNoRef.current.value,
      ucino: uciNoRef.current.value,
    };

    //console.log(payload);
    let response = await AddClientDependent(id, payload);
    //console.log('PostResponse:', response);

    if (response.status == 200) {
      setLoading(false);
      props.setMessage('Client saved successfully.');
      props.setSaved(true);
      props.setOpen(true);
      let clientSaved = client;
      clientSaved.clientDependents = response.data;
      setClient(clientSaved);
      // setTimeout(() => {
      //   navigate(`/app/EditClient/${response.data.id}`);
      // }, 2000);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      setLoading(false);
      // setPosting(false);
    }
  };

  const deleteDependents = async (rowId) => {
    setLoading(true);
    event.preventDefault();
    let response = await DeleteClientDependent(rowId);
    //console.log('RRRRR', response);
    if (response.status == 200) {
      setLoading(false);
      props.setMessage('Client saved successfully.');
      props.setSaved(true);
      props.setOpen(true);
      let clientSaved = client;
      clientSaved.clientDependents = response.data;
      setClient(clientSaved);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      setLoading(false);
      // setPosting(false);
    }
  };
  return (
    <>
      <form onSubmit={SaveUser}>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="20vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box component={Paper} p={1}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField label="Name" required variant="outlined" fullWidth size="small" inputRef={nameRef} />
                  </Grid>

                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      label="Date of Birth"
                      type="date"
                      required
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      fullWidth
                      size="small"
                      inputRef={dateOfBirthRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField label="Passport #" variant="outlined" fullWidth size="small" inputRef={passportNoRef} />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField label="UCI #" variant="outlined" fullWidth size="small" inputRef={uciNoRef} />
                  </Grid>

                  <Grid item xs={12} sm={4} md={3}>
                    <Button type="submit" variant="contained">
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <br></br>
              <br></br>
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Sr#</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Date of Birth</TableCell>
                      <TableCell>Passport No</TableCell>
                      <TableCell>UCI No</TableCell>

                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {client?.clientDependents?.map((row, index) => (
                      <TableRow key={index + 1}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{row.name}</TableCell>
                        <TableCell>{row.dateOfBirth?.split('T')[0]}</TableCell>
                        <TableCell>{row.passportNo}</TableCell>
                        <TableCell>{row.ucino}</TableCell>

                        <TableCell>
                          <ModalLayout
                            component={<Trash />}
                            description="Are You Sure you want to Delete?"
                            Hit={() => deleteDependents(row.id)}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        )}
      </form>
    </>
  );
};

export default ClientDependents;
